<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form"
                    :model="model"
                    :rules="validatorRules"
                    slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :label="language['gift_vendor_code']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="bcode">
              <a-input :placeholder="language['common.pleaseInput']+language['gift_vendor_code']"
                       v-model="model.bcode" :disabled="isDisabled"
                       ></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :label="language['gift_user_app']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="appId">
              <a-select v-model="model.appId"
                        :disabled="isDisabled" :placeholder="language['column.pleaseChoose'] + language['ipsys.eventName']" >
                <a-select-option v-for='(v,k) in appDataMap' :key='k' :value='k' :label='v'>
                  {{ v }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :label="language['gift_vendor_name']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="name">
              <a-input v-model.trim="model.name"
                       :placeholder="language['common.pleaseInput'] + language['gift_vendor_name']"
                       :disabled="isDisabled"></a-input>
            </a-form-model-item>
          </a-col>

<!--          <a-col :span="12">
            <a-form-model-item :label="language['gift_vendor_industry']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="industry">
              <j-dict-select-tag v-model="model.industry"
                                 :placeholder="language['common.pleaseChoose'] + language['gift_vendor_industry']"
                                 :type="'list'"
                                 dictCode="gift_industry"
                                 :disabled="formDisabled" />
            </a-form-model-item>
          </a-col>-->
          <a-col :span="12">
            <a-form-model-item :label="language['construct.contactPerson']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="contact">
              <a-input v-model="model.contact"
                       :placeholder="language['common.pleaseInput'] + language['construct.contactPerson']"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['ipsys.contact_no']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="phone">
              <a-input v-model="model.phone"
                       :placeholder="language['common.pleaseInput'] + language['ipsys.contact_no']"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item label="抽佣比例(%)"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="commission">
              <a-input v-model="model.commission"
                       placeholder="请输入抽佣比例"
                       style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="账期"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="paymentDays">
              <j-dict-select-tag v-model="model.paymentDays"
                                 :type="'list'"
                                 dictCode="gift_paymentDays"
                                 :disabled="formDisabled" />
            </a-form-model-item>
          </a-col> -->
          <a-col :span="12">
            <a-form-model-item :label="language['gift_vendor_address']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="address">
              <a-input v-model="model.address"
                       :placeholder="language['common.pleaseInput'] + language['gift_vendor_address']"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-model-item label="商户简介" :labelCol="labelCol2" :wrapperCol="wrapperCol" prop="introduction">
              <a-textarea v-model="model.introduction" placeholder="请输入商户简介" :auto-size="{ minRows: 3, maxRows: 5 }"></a-textarea>
            </a-form-model-item>
          </a-col> -->
          <a-col :span="12">
            <a-form-model-item :label="language['gift_vendor_logo']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="logo">
              <j-image-upload class="avatar-uploader"
                              :text="language['common.uploadButton']"
                              v-model="model.logo"
                              :upload-source="uploadSource"
                              :isMultiple="false"
                              :maxSize=200
                              :disabled="disableSubmit"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['gift_vendor_license']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="businessLicense">
              <j-image-upload class="avatar-uploader"
                              :text="language['common.uploadButton']"
                              v-model="model.businessLicense"
                              :upload-source="uploadSource"
                              :isMultiple="false"
                              :maxSize=200
                              :disabled="disableSubmit"></j-image-upload>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :label="language['gift_merchant_code']"
                               :labelCol="labelCol" prop="code"
                               :wrapperCol="wrapperCol">
              <a-input :placeholder="language['gift.vendor.merchant']"
                       v-model="model.code" :disabled="isDisabled"
                       ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['gift_merchant_name']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="businessName">
              <a-input v-model.trim="model.businessName"
                       :placeholder="language['common.pleaseInput'] + language['gift_merchant_name']"
                       :disabled="isDisabled"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item :label="language['gift_vendor_story']"
                               :labelCol="labelCol3"
                               :wrapperCol="wrapperCol3"
                               prop="story">
              <j-editor v-model="model.story"
                        style="margin-left:10px ;"
                        :disabled="disableSubmit"
                        :plugins="JEitorPlugins"></j-editor>
            </a-form-model-item>
          </a-col>

        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JEditor from '@/components/jeecg/JEditor'

export default {
  name: 'GiftVendorForm',
  components: {
    JEditor,
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    appDataMap:{

    }
  },
  data() {
    const language = this.$store.getters.language
    return {
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 2 },
      },

      labelCol3: {
        xs: { span: 24 },
        sm: { span: 2 },
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 21 },
      },

      confirmLoading: false,
      validatorRules: {
        bcode: [{ required: true, message: language['common.pleaseInput']+language['gift_vendor_code'] }],
        appId: [{ required: true, message: language['column.pleaseChoose'] + language['ipsys.eventName'] }],
        name: [{ required: true, message: language['common.pleaseInput'] + language['gift_vendor_name'] }],
       /* industry: [{ required: true, message: language['common.pleaseChoose'] + language['gift_vendor_industry'] }],*/
        address: [{ required: true, message: language['common.pleaseInput'] + language['gift_vendor_address'] }],
        contact: [{ required: true, message: language['common.pleaseInput'] + language['construct.contactPerson'] }],
        phone: [
          { required: true, message: language['common.pleaseInput'] + language['ipsys.contact_no'] },
          //     { validator: this.validatePhone },
        ],
        code: [{ required: true, message: language['gift.vendor.merchant'] }],
        story: [{ required: true, message: language['common.pleaseInput'] + language['gift_vendor_story'] }],
        businessName: [{ required: true, message: language['common.pleaseInput'] + language['gift_merchant_name'] }]
      },
      url: {
        add: '/gift/vendor/add',
        edit: '/gift/vendor/edit',
        queryById: '/gift/vendor/queryById',
      },
      isDisabled: false,
      JEitorPlugins: 'lists link table textcolor wordcount contextmenu fullscreen',
      uploadSource: 'gift',
      type: 'add'
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    },
    language() {
      return this.$store.getters.language
    },
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
  },
  methods: {
    add() {
      this.model = Object.assign({}, this.modelDefault)
      this.visible = true
      this.isDisabled = this.modelDefault.code ? true : false
      this.type = 'add'
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
      this.isDisabled = record.code ? true : false
      this.type = 'edit'
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (this.type === 'add') {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },

    //手机号校验
    validatePhone(rule, value, callback) {
      let that = this
      if (!value) {
        callback()
      } else {
        if (new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)) {
          callback()
        } else {
          callback('請輸入正確格式的手機號碼')
        }
      }
    },
  },
}
</script>
